import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Row, Col } from 'antd';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';

class NewFilterDatePicker extends Component {
  _onValidate = (err, formValues) => {
    const { onSubmitForm } = this.props;
    if (!err) {
      const datePickerValue = moment(formValues.datePicker).format(
        'YYYY-MM-DD',
      );
      onSubmitForm(datePickerValue);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderForm = () => {
    const { onCancelForm } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col>
            <Form.Item required={false} colon={false}>
              {getFieldDecorator('datePicker', {
                rules: [
                  {
                    required: true,
                    message: 'date required',
                  },
                ],
              })(<DatePicker className="date-picker-style" />)}
            </Form.Item>
          </Col>

          <Button className="btn cancel-btn" onClick={onCancelForm}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" className="btn">
            Submit
          </Button>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

NewFilterDatePicker.propTypes = {
  form: PropTypes.object,
  onCancelForm: PropTypes.func,
  onSubmitForm: PropTypes.func,
};

export default NewFilterDatePicker;
